import usePageTitle from "hooks/usePageTitle";
import RecordIdCard from "routes/ui_sandbox/RecordIdCard";
import useRecordIdParam from "routes/ui_sandbox/useRecordIdParam";
import ContactFormLoader from "routes/ui_sandbox/pages/ContactFormLoader";

const ContactFormPage = () => {
  usePageTitle("Contact Form");
  const { id, setId, clearId } = useRecordIdParam();

  return (
    <>
      <RecordIdCard
        label="Contact ID"
        description="Leave empty to create a contact, or load an id to edit one."
        id={id}
        onLoad={setId}
        onClear={clearId}
      />
      {/* A create switches to editing the saved contact. */}
      <ContactFormLoader
        key={id}
        id={id}
        onSaved={saved => setId(saved?.id ?? id)}
        onCancel={clearId}
      />
    </>
  );
};

export default ContactFormPage;
